import { render, staticRenderFns } from "./B2C.vue?vue&type=template&id=43e6332c&scoped=true&"
import script from "./B2C.vue?vue&type=script&lang=js&"
export * from "./B2C.vue?vue&type=script&lang=js&"
import style0 from "./B2C.vue?vue&type=style&index=0&id=43e6332c&scoped=true&lang=scss&"
import style1 from "./B2C.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e6332c",
  null
  
)

export default component.exports